import { render, staticRenderFns } from "./dSphereTonesSpider.vue?vue&type=template&id=79853278&"
import script from "./dSphereTonesSpider.vue?vue&type=script&lang=js&"
export * from "./dSphereTonesSpider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports